import SaveStaffRequest from "@/usecases/requests/save-staff-request";
import SaveStaffInteractor from "@/usecases/interactors/save-staff-interactor";
import StaffGateway from "@/usecases/gateways/staff-gateway";
import ServiceRoleGateway from "@/usecases/gateways/service-role-gateway";
import Staff from "@/entities/staff";

export default class SaveStaffCommand implements SaveStaffInteractor {
  public constructor(
    private sApi: StaffGateway,
    private rApi: ServiceRoleGateway
  ) {}

  public async handle(req: SaveStaffRequest) {
    const s: Staff = await this.sApi.save(req);
    if (!s.id) return;
    if (req.roleId) {
      await this.rApi.assign(s.id, req.roleId);
    } else {
      await this.rApi.remove(s.id);
    }
  }
}
